// src/components/shared/useDokumentListe.jsx
// Generische Liste erfasster/verarbeiteter Dokumente für die Sichtkorrektur-Tabelle -
// unabhängig von der Dokumentklasse. Jeder Eintrag: { id, file, dokument, validation }
//   - id: clientseitig generierte, stabile Kennung (React-Keys, Bearbeiten, Löschen)
//   - file: Ursprungsdatei (File-Objekt) für die Vorschau, oder null
//   - dokument: das (ggf. korrigierte) extrahierte Dokument-Objekt (Rechnung, künftig z.B.
//     Lieferschein, ...) - Feldname bewusst generisch, nicht "rechnung"
//   - validation: rohe ValidationResult vom Backend ({ valid, remarks, validationJson })
import { useState, useCallback } from 'react'

let nextId = 1
const erzeugeId = () => String(nextId++)

export function useDokumentListe () {
  const [eintraege, setEintraege] = useState([])

  const hinzufuegen = useCallback(({ file, dokument, validation }) => {
    const id = erzeugeId()
    setEintraege(liste => [...liste, { id, file, dokument, validation }])
    return id
  }, [])

  const aktualisieren = useCallback((id, teilweiseDaten) => {
    setEintraege(liste =>
      liste.map(eintrag =>
        eintrag.id === id ? { ...eintrag, ...teilweiseDaten } : eintrag
      )
    )
  }, [])

  const entfernen = useCallback(id => {
    setEintraege(liste => liste.filter(eintrag => eintrag.id !== id))
  }, [])

  const alleEntfernen = useCallback(() => {
    setEintraege([])
  }, [])

  return { eintraege, hinzufuegen, aktualisieren, entfernen, alleEntfernen }
}

export default useDokumentListe
